import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

Vue.use(Router)

let router = new Router({
    // mode: 'history',
    routes: [
        // 一级路由 - 无需登录
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login')
        },
        {
            path: '/chatMap',
            name: 'chatMap',
            component: () => import('@/views/map')
        },
        {
            path: '/chatMap2',
            name: 'chatMap2',
            component: () => import('@/views/map/index2.vue')
        },
        // 需要 MainPage 布局的路由
        {
            path: '/',
            component: () => import('./MainPage.vue'),
            redirect: '/admin/admin_report_home',
            children: [
                // patient 模块
                {
                    path: 'patient/patient_list',
                    name: '/patient/patient_list',
                    component: () => import('@/views/patient/PatientList'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'patient/basic',
                    name: '/patient/basic',
                    component: () => import('@/views/patient/Basic'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'patient/health',
                    name: '/patient/health',
                    component: () => import('@/views/patient/Health'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'patient/rec',
                    name: '/patient/rec',
                    component: () => import('@/views/patient/PatientRecommend'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'patient/treatment',
                    name: '/patient/treatment',
                    component: () => import('@/views/patient/Treatment'),
                    meta: { requiresAuth: true }
                },
                // clinic 模块
                {
                    path: 'clinic/clinic_info',
                    name: '/clinic/clinic_info',
                    component: () => import('@/views/clinic/ClinicInfo'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'clinic/clinic_list',
                    name: '/clinic/clinic_list',
                    component: () => import('@/views/clinic/ClinicList'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'clinic/clinic_doctor_stat',
                    name: '/clinic/clinic_doctor_stat',
                    component: () => import('@/views/clinic/ClinicDoctorStat'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'clinic/clinic_drug_stat',
                    name: '/clinic/clinic_drug_stat',
                    component: () => import('@/views/clinic/ClinicDrugStat'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'clinic/clinic_acupoint_stat',
                    name: '/clinic/clinic_acupoint_stat',
                    component: () => import('@/views/clinic/ClinicAcupointStat'),
                    meta: { requiresAuth: true }
                },
                // profile 模块
                {
                    path: 'profile/profile_global',
                    name: '/profile/profile_global',
                    component: () => import('@/views/profile/GlobalProfile'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'profile/profile_chronic_disease_view',
                    name: '/profile/profile_chronic_disease_view',
                    component: () => import('@/views/profile/ChronicDiseaseView'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: () => import('@/views/ProfileHome'),
                    meta: { requiresAuth: true }
                },
                // admin 模块
                {
                    path: 'admin/admin_desc_view',
                    name: '/admin/admin_desc_view',
                    component: () => import('@/views/admin/DescView'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'admin/admin_diagnose_view',
                    name: '/admin/admin_diagnose_view',
                    component: () => import('@/views/admin/DiagnoseView'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'admin/admin_trigger_view',
                    name: '/admin/admin_trigger_view',
                    component: () => import('@/views/admin/TriggerView'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'admin/admin_predict_view',
                    name: '/admin/admin_predict_view',
                    component: () => import('@/views/admin/PredictiveView'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'admin/admin_report_home',
                    name: '/admin/admin_report_home',
                    component: () => import('@/views/admin/ReportHome'),
                    meta: { requiresAuth: true }
                },
                // service 模块
                {
                    path: 'service/ensurance',
                    name: '/service/ensurance',
                    component: () => import('@/views/out_service/EnsuranceService'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'service/finiance',
                    name: '/service/finiance',
                    component: () => import('@/views/out_service/FinianceService'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'service/entity',
                    name: '/service/entity',
                    component: () => import('@/views/out_service/EntityService'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'service/medical_sim_service',
                    name: '/service/medical_sim_service',
                    component: () => import('@/views/out_service/MedicalSimService'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'service/user_disease_predict',
                    name: '/service/user_disease_predict',
                    component: () => import('@/views/out_service/UserDiseasePredict'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'service',
                    name: 'service',
                    component: () => import('@/views/ServiceView'),
                    meta: { requiresAuth: true }
                },
                // data_processor 模块
                {
                    path: 'data_processor/data_mixup',
                    name: '/data_processor/data_mixup',
                    component: () => import('@/views/data_processor/DataMixup'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'data_processor/data_encrypt',
                    name: '/data_processor/data_encrypt',
                    component: () => import('@/views/data_processor/DataEncrypt'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'data_processor/data_tracer',
                    name: '/data_processor/data_tracer',
                    component: () => import('@/views/data_processor/DataTracer'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'data_processor/data_fillup',
                    name: '/data_processor/data_fillup',
                    component: () => import('@/views/data_processor/AddressFillup'),
                    meta: { requiresAuth: true }
                },
                // 其他模块
                {
                    path: 'map/:path',
                    name: 'chinaMap',
                    component: () => import('@/views/charts/chinamap.vue'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'line/:path',
                    name: 'line',
                    component: () => import('@/views/charts/line.vue'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'kcl_pie',
                    name: 'kcl_pie',
                    component: () => import('@/views/charts/pie.vue'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'disease_anno/disease_anno',
                    name: '/disease_anno/disease_anno',
                    component: () => import('@/views/DiseaseAnnoView'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'largeScreenMonitor',
                    name: 'largeScreenMonitor',
                    component: () => import('@/views/large_screen/LargeScreenV3'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'dataFactory',
                    name: 'dataFactory',
                    component: () => import('@/views/DataFactory'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'dataSearch/dataSearch',
                    name: '/dataSearch/dataSearch',
                    component: () => import('@/views/DataSearch'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'dataPerf/dataPerf',
                    name: '/dataPerf/dataPerf',
                    component: () => import('@/views/DataPerf'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'systemSettings/userManager',
                    name: '/systemSettings/userManager',
                    component: () => import('@/views/setting_manager/staff'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'systemSettings/roleManager',
                    name: '/systemSettings/roleManager',
                    component: () => import('@/views/setting_manager/RoleManager'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'baseTable',
                    name: 'baseTable',
                    component: () => import('@/views/data_factory/hdfs/BaseTable'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'upload',
                    name: 'upload',
                    component: () => import('@/views/data_factory/hdfs/Upload'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'readme',
                    name: 'readme',
                    component: () => import('@/views/data_factory/hdfs/Readme'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'api/api',
                    name: 'api',
                    component: () => import('@/views/api/ApiInfo'),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'demo/demo',
                    name: 'demo',
                    component: () => import('@/views/tests/Demo')
                },
                {
                    path: 'thirdParty/tijian',
                    name: '/thirdParty/tijian',
                    component: () => import('@/views/third_party/TijianMain')
                },
                {
                    path: 'thirdParty/tijian_info',
                    name: '/thirdParty/tijian_info',
                    component: () => import('@/views/third_party/TijianInfo')
                },
                {
                    path: 'loading-demo',
                    name: 'loading-demo',
                    component: () => import('@/views/LoadingDemo'),
                    meta: { requiresAuth: true }
                }
            ]
        }
    ]
})


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }
        next('/login?next=' + encodeURIComponent(to.fullPath))
    } else {
        store.commit('hideLoading')
        next()
    }
})

export default router
